/**
 * Contains part of the utils in v3 nb.ui.d3metric.
 */

export const genAxis = (min: number, max: number) => ({ min, max })

export const genData = (label: string, value: number | string) => ({
  label,
  value
})

export const genSeriesItem = (label: string, data: any[], displayValue?: string) => ({
  label,
  data,
  displayValue
})
